import { Type } from '@sinclair/typebox';
import { NullishType } from '../../../../standard-schema.js';
const StakeholdersBaseSchema = Type.Object({
    id: Type.String(),
    userId: NullishType(Type.String()),
    name: NullishType(Type.String()),
    role: NullishType(Type.String()),
    phone: NullishType(Type.String()),
    email: NullishType(Type.String()),
    order: Type.Integer(),
    organisationId: Type.String(),
});
export const StakeholdersSchema = StakeholdersBaseSchema;
export const StakeholdersWithoutOrgIdSchema = Type.Omit(StakeholdersSchema, ['organisationId']);
export const StakeholderInputSchema = Type.Object({
    id: Type.Optional(Type.String()),
    userId: Type.Optional(Type.String()),
    name: NullishType(Type.String()),
    role: NullishType(Type.String()),
    phone: NullishType(Type.String()),
    email: NullishType(Type.String()),
    order: Type.Integer(),
});
